import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { ModalContent, ModalHeader } from './styled.conductSkeleton';
import { ButtonBlockColumn } from './../../../common/sharedStyledComponents/GenericStyles.styled';

export function MyAuditConductModalSkeleton () {
  return (
    <>
      <ModalHeader>
        <Skeleton height={24} count={2} />
      </ModalHeader>
      <ModalContent>
        <Skeleton count={3} />
      </ModalContent>
      <ButtonBlockColumn>
        <Skeleton height={48} borderRadius={4} />
        <Skeleton height={48} borderRadius={4} />
      </ButtonBlockColumn>
    </>
  );
}
